import { render, staticRenderFns } from "./ModalFormBusinessUnit.vue?vue&type=template&id=08685695"
import script from "./ModalFormBusinessUnit.vue?vue&type=script&lang=js"
export * from "./ModalFormBusinessUnit.vue?vue&type=script&lang=js"
import style0 from "./ModalFormBusinessUnit.vue?vue&type=style&index=0&id=08685695&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08685695')) {
      api.createRecord('08685695', component.options)
    } else {
      api.reload('08685695', component.options)
    }
    module.hot.accept("./ModalFormBusinessUnit.vue?vue&type=template&id=08685695", function () {
      api.rerender('08685695', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalFormBusinessUnit.vue"
export default component.exports